<template>
    <div class="wrap">
      <div class="content">
          <base-header :name="user_name" :topOnly="flag_top" :account_list="account_list"></base-header>

          <div class="main-time"></div>

          <div class="part part-1">
            <div class="task task1">
              <div class="title">每日签到</div>
              <div class="img-content">
                <img src="../../assets/img/newYearActivity/task-img1.png" alt="" title="灵蛇之珠"/>
              </div>
              <div class="name">灵蛇之珠*1</div>
              <div :class="`btn ${skinStatus === 0 ? '' : 'over'}`" @click="getSkin"></div>
            </div>

            <div class="task task2">
              <div class="title">每日赛季游戏首胜<br>（10分钟以上）</div>
              <div class="img-content">
                <img src="../../assets/img/newYearActivity/task-img1.png" alt="" title="灵蛇之珠"/>
              </div>
              <div class="name">灵蛇之珠*1</div>
              <div :class="`btn ${ gameTimeStatus }`" @click="usePacket(gameTimeInfo, gameTimeStatus, 2)"></div>
            </div>

            <div class="task task3">
              <div class="title">赛季模式累计获<br>得5万金币</div>
              <div class="img-content">
                <img src="../../assets/img/newYearActivity/task-img1.png" alt="" title="灵蛇之珠"/>
              </div>
              <div class="name">灵蛇之珠*8</div>
              <div :class="`btn ${ gameTotalMoneyStatus }`" @click="usePacket(gameTotalMoneyInfo, gameTotalMoneyStatus, 3)"></div>
              <div class="text">{{ filterMoney(totalMoney) }}</div>
            </div>

            <div class="task task4">
              <div class="title">赛季模式累计完<br>成80次击杀</div>
              <div class="img-content">
                <img src="../../assets/img/newYearActivity/task-img1.png" alt="" title="灵蛇之珠"/>
              </div>
              <div class="name">灵蛇之珠*8</div>
              <div :class="`btn ${ gameTotalKillStatus }`" @click="usePacket(gameTotalKillInfo, gameTotalKillStatus, 4)"></div>
              <div class="text">{{ totalKill }}次</div>
            </div>

            <div class="task task5">
              <div class="title">累计获得15场赛<br>季游戏胜利</div>
              <div class="img-content">
                <img src="../../assets/img/newYearActivity/task-img1.png" alt="" title="灵蛇之珠"/>
              </div>
              <div class="name">灵蛇之珠*8</div>
              <div :class="`btn ${ gameWinTimesStatus }`" @click="usePacket(gameWinTimesInfo, gameWinTimesStatus, 5)"></div>
              <div class="text">{{ winTimes }}场</div>
            </div>

            <div class="task task6">
              <div class="title">累计签到7天</div>
              <div class="img-content">
                <img src="../../assets/img/newYearActivity/task-img2.png" alt="" title="灵蛇之珠"/>
                <div class="play-icon" @click="openPop('', 4, '')"></div>
              </div>
              <div class="name">皮肤头像框三选一</div>
              <div :class="`btn ${ skinInfoStatus == 'over' ? 'over' : skinDay >= 7 ? 'get' : '' }`" @click="openPop(skinInfo, 1, skinInfoStatus == 'over' ? 'over' : skinDay >= 7 ? 'get' : '')"></div>
              <div class="text">{{ skinDay }}天</div>
            </div>
          </div>

          <div class="part part-2">
            <div class="part-text2">请至电脑端进行购买操作</div>
            <div class="part-text1">单个福袋 <span>每日首次购买仅需99</span> 酒币，首次购买后恢复原价：<span>199</span>酒币</div>
            <div class="part-bg"></div>
          </div>

        <div class="part part-3">
          <div class="part-text2">请至电脑端进行兑换操作</div>
          <div class="part-text1">我的灵蛇之珠： <span> {{ exchangeNum }}</span> 个</div>
          <div class="part-bg"></div>
        </div>

          <div class="mate-info"></div>
      </div>

      <div  class="pop-content" v-if="showPop">
        <div class="pop touxiang" v-if="popType == 'touxiang'">
          <div class="close" @click="showPop = false"></div>
          <div class="title">皮肤头像框3选1</div>
          <div class="inner">
            <div
              class="pifu-list"
              v-for="(item, index) in pifuList.packet"
              :key="index"
            >
              <div class="inner-title">{{ item.name }}</div>
              <div
                :class="`img-content ${item.isActive ? 'active' : '' }`"
                @click="changePifuStatus(item, index)"
              >
                <img src="../../assets/img/newYearActivity/pf-1.png" :alt="item.name" v-if="index === 0">
                <img src="../../assets/img/newYearActivity/pf-2.png" :alt="item.name" v-else-if="index === 1">
                <img
                  :src="`https://cdn.09game.com/resources/item/dj_${ item.id }_200.png`"
                  :alt="item.name"
                  v-else
                >
                <div class="play-icon" v-if="index !== 2" @click="openPop2(item)"></div>
                <span v-if="index !== 2">或</span>
                <div class="have" v-if="item.have"></div>
                <div class="active-img" v-if="item.isActive"></div>
              </div>
              <p v-if="index === 2">该物品重复领取</br>返还灵蛇之珠：37</p>
            </div>
            <div :class="`btn ${pifuStatus}`" @click="usePacket2"><span>选择奖励</span></div>
          </div>
        </div>

        <div class="pop touxiang" v-if="popType == 'zhanshi'">
          <div class="close" @click="showPop = false"></div>
          <div class="title">皮肤头像框3选1</div>
          <div class="inner">
            <div
              class="pifu-list"
              v-for="(item, index) in pifuList.packet"
              :key="index"
            >
              <div class="inner-title">{{ item.name }}</div>
              <div class="img-content ">
                <img src="../../assets/img/newYearActivity/pf-1.png" :alt="item.name" v-if="index === 0">
                <img src="../../assets/img/newYearActivity/pf-2.png" :alt="item.name" v-else-if="index === 1">
                <img
                  :src="`https://cdn.09game.com/resources/item/dj_3008_200.png`"
                  :alt="item.name"
                  v-else
                >
                <div class="play-icon" v-if="index !== 2" @click="openPop2(item)"></div>
                <span v-if="index !== 2">或</span>
                <div class="have" v-if="item.have"></div>
              </div>
              <p v-if="index === 2">该物品重复领取</br>返还灵蛇之珠：37</p>
            </div>
          </div>
        </div>
      </div>

      <div class="pop-content2" v-if="showPop2">
        <div class="pop">
          <div class="close" @click="showPop2 = false"></div>
          <div class="title">{{ videoName }}</div>
          <div class="inner">
            <div class="video" style="width: 5.96rem;height:34.0rem;margin:0 auto;">
              <video :src="`https://cdn.09game.com/resources/flv/${videoId}.mp4`"
                     style="display: block;width: 5.96rem;height:3.40rem;margin:0 auto;" v-if="videoId" autoplay
                     loop></video>
            </div>
          </div>
        </div>
      </div>

      <div class="mark" v-if="showPop || showPop2"></div>
    </div>
</template>

<script>
import { isToday, setEndTime } from '@/utils/common'
import { baseUrls } from '@/utils/baseUrlConfig'
import storage from '@/utils/Storage'

let now = new Date().setHours(0, 0, 1, 0)
let today = new Date(now).getDay()
today = today == 0 ? 7 : today
let mouse, _09game = null
const hd_url = 'https://hd.09game.com/newyear/'
const shop_url = baseUrls.shop_url
const base_url = baseUrls.user_url

export default {
  name: 'newYearActivity',
  data () {
    return {
      token: this.$storage.getToken(),
      user_name: '',
      flag_top: true,
      account_list: [],
      appId: 91890, // 活动ID
      itemId: 20137, // 灵蛇之珠道具ID
      timer: null, //定时器
      nowTime: new Date(), //当前日期
      skinStatus: 0, // 签到状态
      btnLock: false, // 按钮是否可点
      pifuList: {}, // 累积签到8天,3选一皮肤
      pifuStatus: '', // 选择皮肤按钮状态
      skinDay: 0, // 签到多少天
      totalMoney: 0, // 累计获得总金额
      totalKill: 0, // 总击杀数
      winTimes: 0, // 累计获得游戏场次
      gameTimeInfo: {}, // 每日赛季游戏首胜
      gameTimeStatus: '',
      gameTotalMoneyInfo: {}, // 赛季模式累计获金币
      gameTotalMoneyStatus: '',
      gameTotalKillInfo: {}, // 赛季模式累计完击杀
      gameTotalKillStatus: '',
      gameWinTimesInfo: {}, // 累计获得场赛
      gameWinTimesStatus: '',
      skinInfo: {}, // 皮肤头像框三选一
      skinInfoStatus: {}, // 皮肤头像框三选一
      showPop: false, // 弹出框显示
      showPop2: false, // 弹出框显示
      popType: '', // 弹出层类型 touxiang: 三选一头像 zhanshi：展示选择过的头像
      exchangeNum: 0, // 我的灵珠
      videoId: '', // 道具预览视频链接
      videoName: ''
    }
  },
  created() {
    // setEndTime('2025-02-04 00:00:01')
    this.requireToken()
  },
  mounted() {
    document.addEventListener('scroll', this.downFunc)
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.downFunc)
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.$common.checkToken(vm.token)) {
        vm.$http.set_anchor(13, vm.token)
      }
    })
  },
  methods: {
    requireToken() {
      let Ucookie = this.token
      if (Ucookie != null) {
        let now = new Date().getTime()
        if (now >= Ucookie.split('-')[3] * 1000) {
          //token过期
          this.get_auth()
        } else {
          this.init()
        }
      } else {
        this.get_auth()
      }
    },
    get_auth() {
      window.location.replace(base_url + '/GetWxOpenid?fromPage=newYearActivity')
    },
    // 初始化数据
    init() {
      Object.assign(this.$data, this.$options.data.call(this))
      this.token = this.$storage.getToken()
      this.queryCgfPacket()
      this.query_user_baseInfo()
      this.getNewYearConfig()
      this.queryMyTask()
      this.exchangeNum = this.queryMyItemCount(this.itemId)
      // this.queryMyPacket()
    },
    // 获取用户基础信息（是否为plus，以及plus的剩余天数）
    query_user_baseInfo() {
      $.ajax({
        url: 'https://users.09game.com/home/GetUserPub?user_id=' + this.token.split('-')[0],
        success: (res) => {
          if (res.result == 0) {
            var u = res.temp[0]
            this.user_name = u.user_name
            this.$storage.setUserId(u.user_id)
            this.$storage.setUserName(u.user_name)
          } else {
            console.log('获取用户信息错误，错误码：' + res.result)
          }
        },
      })
      this.$http.getAllUser(this.token).then((res) => {
        if (res.result == 0 && res.msg && res.msg.length > 0) {
          this.account_list = res.msg
          this.$storage.setAccountList(JSON.stringify(res.msg))
        } else {
          this.account_list = []
        }
      })
    },
    // 获取所有任务数据
    getNewYearConfig() {
      this.$http.q_hd('GetNewYearConfig', hd_url, { token: this.token }).then(res => {
        if (res.code ===0) {
          let { skin_status: skinStatus, skin_day: skinDay,total_money: totalMoney,
            total_kill: totalKill, total_win_times: winTimes } = res
          this.skinStatus = skinStatus
          this.skinDay = skinDay
          this.totalKill = totalKill
          this.winTimes = winTimes
          this.totalMoney = totalMoney
        }
      })
    },
    // 当日签到
    getSkin() {
      if (this.skinStatus === 1) {
        return
      }
      if (this.btnLock) {
        return
      }
      this.btnLock = true;

      this.$http.q_hd('NewYearSkin', hd_url, { token: this.token }).then((res) => {
        let element = `.task.task1 .btn`
        let text = ''
        if (res.code === 0) {
          this.exchangeNum = this.queryMyItemCount(this.itemId)
          this.getNewYearConfig()
          text = '签到成功'
          this.mate_show(element, text,-40,5);
        } else {
          text = res.msg
          this.mate_show(element, text,-40,5);
        }
        this.btnLock = false;
      })
    },
    // 查询礼包配置
    queryCgfPacket() {
      return this.$http.q_cfg_packet(this.appId).then((res) => {
        if (res.code == 0) {
          let { records } = res;
          let pifuList = {}; // 累积签到7天,3选一皮肤

          records.map(item => {
            // 累积签到7天,3选一皮肤
            if (item.packet_id === 918906) {
              item.packet = []
              for (let o = 1; o <= 6; o++) {
                if (item['gift' + o + '_setting']) {
                  item.packet.push(JSON.parse(item['gift' + o + '_setting']));
                }
              }
              item.packet.map(item => {
                item.active = false
                item.amount = this.queryMyItemCount(item.id) // 查询数量
                item.have = item.amount >= 2000
              })
              pifuList = item
            }
          })
          this.pifuList = pifuList
        }
      })
    },
    // 查询我的礼包
    queryMyPacket() {
      return this.$http.q_my_packet(this.appId, this.token).then((res) => {
        if (res.code === 0) {
          let data = res.records
          for (let i in data) {
            let element = data[i]
            // 每日赛季游戏首胜
            if (element.packet_id == 918902) {
                if (this.gameTimeInfo.over_step >= this.gameTimeInfo.total_step) {
                  if (element.balance > 0 && element.expire_days > 0) {
                    this.gameTimeStatus = 'get'
                  } else if(element.balance == 0 && element.expire_days > 0) {
                    this.gameTimeStatus = 'over'
                  }
                } else {
                  this.gameTimeStatus = ''
                }
              this.gameTimeInfo.packet = element
            }

            // 赛季模式累计获金币
            if (element.packet_id == 918903) {
              let totalMoney = this.totalMoney
              if (totalMoney >= 50000) {
                if (element.balance > 0) {
                  this.gameTotalMoneyStatus = 'get'
                } else if(element.balance == 0 && element.sub_count > 0) {
                  this.gameTotalMoneyStatus = 'over'
                }
              } else {
                this.gameTotalMoneyStatus = ''
              }
              this.gameTotalMoneyInfo.packet = element
            }

            // 赛季模式累计完击杀
            if (element.packet_id == 918904) {
              let totalKill = this.totalKill
              if (totalKill >= 80) {
                if (element.balance > 0) {
                  this.gameTotalKillStatus = 'get'
                } else if(element.balance == 0 && element.sub_count > 0) {
                  this.gameTotalKillStatus = 'over'
                }
              } else {
                this.gameTotalKillStatus = ''
              }
              this.gameTotalKillInfo.packet = element
            }

            // 累计获得场赛
            if (element.packet_id == 918905) {
              let winTimes = this.winTimes
              if (winTimes >= 15) {
                if (element.balance > 0) {
                  this.gameWinTimesStatus = 'get'
                } else if(element.balance == 0 && element.sub_count > 0) {
                  this.gameWinTimesStatus = 'over'
                }
              } else {
                this.gameWinTimesStatus = ''
              }
              this.gameWinTimesInfo.packet = element
            }

            // 皮肤头像框三选一
            let skinDay = this.skinDay
            if (element.packet_id == 918906) {
              if(element.balance == 0 && element.sub_count > 0) {
                this.skinInfoStatus = 'over';
              } else {
                this.skinInfoStatus = '';
              }
              this.skinInfo.packet = element
            }
          }
        }
      })
    },
    // 我的任务配置
    queryMyTask() {
      return this.$http.q_my_task2(this.appId, this.token, 1).then((res) => {
        if (res.code === 0) {
          let records = res.records
          records.map(item => {
            if (isToday(item.create_time)) {
              this.gameTimeInfo = item
            }
          })
        }
        this.queryMyPacket()
      })
    },
    // 使用礼包
    usePacket(item, type, index) {
      let { packet_id } = item.packet
      if (this.btnLock) {
        return false;
      }

      if (type != 'get') {
        return false
      }

      return this.$http.use_packet(packet_id, this.token, 1).then((res) => {
        let text = '';
        let element = `.part.part-1 .task.task${index} .btn`;
        if (res.code == 0 ) {
          this.exchangeNum = this.queryMyItemCount(this.itemId)
          this.queryMyPacket();
          text = '领取成功';
          this.mate_show(element, text, -40, 5)
        } else {
          text = res.msg ? res.msg : '领取失败!';
          this.btnLock = false;
          this.mate_show(element, text, -40, 5)
        }
      })
    },
    usePacket2() {
      if (this.pifuStatus !='get') {
        return
      }

      let activeItem = {}
      let activeIndex = {}
      this.pifuList.packet.map((item, index) => {
        if (item.isActive) {
          activeItem  = item
          activeIndex  = index
        }
      })

      if (this.btnLock) {
        return false;
      }

      this.$http.q_hd('sendNewYearPacket', hd_url, { token: this.token, opt: activeIndex }).then(res => {
        let text = '';
        let element = `.part.part-1 .task.task6 .btn`;
        if (res.code === 0) {
          this.queryMyPacket()
          this.pifuList.packet.map(item => {
            item.amount = this.queryMyItemCount(item.id) // 查询数量
            item.have = item.amount >= 2000
          })
          this.exchangeNum = this.queryMyItemCount(this.itemId)
          text = '领取成功';
          this.btnLock = false;
          this.showPop = false
          this.mate_show(element, text, -40, 5)
        } else {
          text = res.msg ? res.msg : '领取失败!';
          this.btnLock = false;
          this.showPop = false
          this.mate_show(element, text, -40, 5)
        }
      })
    },
    // 查询我的道具数量
    queryMyItemCount(id) {
      let amount = 0;
      $.ajax({
        url: 'https://shop.09game.com/shop?' + JSON.stringify({
          type: 'q_my_item',
          json: JSON.stringify({
            item_id: id,
            token: this.token
          })
        }),
        async: false,
        success: (res) => {
          if (res.code == 0) {
            amount = res.records[0].amount;
          }
        }
      });
      return amount;
    },
    // 打开弹出岑
    openPop (item, type, status) {
      if (type === 1) {
        // 皮肤3选一
        if (item) {
          if (status != 'get') {
            return;
          }
          this.showPop = true
          this.popType = 'touxiang'
          this.pifuList.packet.map(itemList => itemList.isActive = false)
          this.pifuStatus = ''
        }
      } else {
        // 购买头像
        this.showPop = true
        this.popType = 'zhanshi'
      }
    },
    openPop2(item) {
      // 视频
      this.videoName = item.name.substring(0, 9)
      this.videoId = item.id
      this.showPop2 = true
    },
    // 皮肤头像框3选1选择
    changePifuStatus(item, index) {
      let { id, have } = item


      if ((index == 0 || index == 1) && have) {
        return;
      }
      // 置空选择
      this.pifuList.packet.map(itemList => itemList.isActive = false)
      this.pifuStatus = ''

      // 选择
      this.pifuList.packet.map((itemList, itemIndex) => {
        itemList.isActive = itemList.id === id;
        this.$set(this.pifuList.packet, itemIndex, itemList);
      })
      this.pifuStatus = 'get'
    },
    // 过滤钱
    filterMoney(money) {
      if (money >= 10000) {
        money = (money / 10000).toFixed(2) + '万'
      }
      return money
    },
    mate_show(element, text, offsetTop, offsetLeft = 5) {
      $('.mate-info').html(text)
      var width1 = $(element).width()
      var width = $('.mate-info').width() + 44
      var offWidth = (width1 - width) / 2
      var top = $('.content').offset().top
      var cssTop = $(element).offset().top - top + offsetTop
      var cssLeft = $(element).offset().left + offWidth + offsetLeft
      var css = {
        top: cssTop,
        left: cssLeft,
      }
      if (this.timer) {
        clearTimeout(this.timer)
      }
      $('.mate-info').show().css(css)
      this.timer = setTimeout(function () {
        $('.mate-info').hide().html('')
      }, 3000)
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/newYearActivity/index.scss';
</style>



// WEBPACK FOOTER //
// src/view/2025/newYearActivity.vue